import { Directive, ElementRef, EventEmitter, Injector, Input, Output } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

@Directive({
   // tslint:disable-next-line:directive-selector
   selector: 'am-create-check-button'
})
export class CreateCheckButtonUpgradedDirective extends UpgradeComponent {
   @Output() refresh: EventEmitter<any>;

   constructor(elementRef: ElementRef, injector: Injector) {
      super('amCreateCheckButton', elementRef, injector);
   }
}
